import { render, staticRenderFns } from "./evaluacion-seleccion-proveedores.vue?vue&type=template&id=10d0ad78&scoped=true&"
import script from "./evaluacion-seleccion-proveedores.vue?vue&type=script&lang=js&"
export * from "./evaluacion-seleccion-proveedores.vue?vue&type=script&lang=js&"
import style0 from "./evaluacion-seleccion-proveedores.vue?vue&type=style&index=0&id=10d0ad78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d0ad78",
  null
  
)

export default component.exports